import { SnackbarContent } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import moment from 'moment-timezone';
import * as React from 'react';
import { Subscription } from 'rxjs';
import { authorisationNotification$ } from '../Config/ApplicationConfig';
import styles from './GlobalSnackbar.module.scss';
import { Nullable } from './Types';

const MinDisplayTime = 1000;

export type SnackbarState = {
    open: boolean;
    message: string;
    messageDisplayTime: Nullable<Date>;
    variant: SnackBarVariant;
    closeSnackbar(): void;
    displayMessage(message: string): void;
    displayError(errorMessage: string): void;
};

export enum SnackBarVariant {
    Normal,
    Error
}

export class GlobalSnackbar extends React.Component<{}, SnackbarState> {
    private notifications$$: Nullable<Subscription> = null;

    constructor(props: {}) {
        super(props);

        this.state = {
            open: false,
            message: '',
            messageDisplayTime: null,
            variant: SnackBarVariant.Normal,
            closeSnackbar: this.handleClose,
            displayMessage: this.displayMessage,
            displayError: this.displayError
        };
    }

    componentDidMount() {
        this.notifications$$ = authorisationNotification$.subscribe(notification => {
            if (notification.type === 'display') {
                this.displayMessage(notification.message);
            } else if (notification.type === 'error') {
                this.displayError(notification.message);
            }
        });
    }

    componentWillUnmount() {
        if (this.notifications$$) {
            this.notifications$$.unsubscribe();
        }
    }

    public render() {
        let snackBarVariant = '';

        if (this.state.variant === SnackBarVariant.Error) {
            snackBarVariant = styles.errorSnackbar;
        }

        return (
            <>
                {this.props.children}
                <Snackbar
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.open}
                    onClose={this.handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id'
                    }}
                >
                    <SnackbarContent message={this.state.message} className={snackBarVariant} />
                </Snackbar>
            </>
        );
    }

    private handleClose = () => {
        if (this.state.messageDisplayTime) {
            const displayTime = moment().diff(moment(this.state.messageDisplayTime));
            if (displayTime > MinDisplayTime)
                this.setState({
                    open: false,
                    variant: SnackBarVariant.Normal,
                    messageDisplayTime: null,
                    message: ''
                });
        } else {
            this.setState({
                open: false,
                variant: SnackBarVariant.Normal,
                messageDisplayTime: null,
                message: ''
            });
        }
    };

    private displayError = (message: string) => {
        this.setState({
            message,
            variant: SnackBarVariant.Error,
            messageDisplayTime: new Date(),
            open: true
        });
    };

    private displayMessage = (message: string) => {
        this.setState({
            message,
            variant: SnackBarVariant.Normal,
            messageDisplayTime: new Date(),
            open: true
        });
    };
}
